// client/src/GameScreen.js
import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { fetchScoreboard } from "./api";
import "./GameScreen.css";

const socket = io(); // použije aktuální origin (např. https://www.mojebingo.cz)

function GameScreen({ session }) {
  const { gameId, playerId, playerName, words } = session;

  const [marked, setMarked] = useState(Array(words.length).fill(false));
  const [scoreboard, setScoreboard] = useState([]);
  const [winner, setWinner] = useState(null);
  const [gameOver, setGameOver] = useState(false);

  useEffect(() => {
    socket.emit("joinGameRoom", { gameId });

    // načti scoreboard a zjisti, jestli už někdo nevyhrál
    fetchScoreboard(gameId)
      .then((sb) => {
        setScoreboard(sb);
        const hasWinner = sb.some(
          (p) => p.finished && p.matchedCount === words.length
        );
        if (hasWinner) {
          setGameOver(true);
        }
      })
      .catch(() => {});

    socket.on("scoreboardUpdate", (data) => {
      setScoreboard(data);
    });

    socket.on("playerWon", ({ playerId: winId, name }) => {
      setWinner({ playerId: winId, name });
      setGameOver(true); // ukonči hru pro všechny
    });

    return () => {
      socket.off("scoreboardUpdate");
      socket.off("playerWon");
    };
  }, [gameId, words.length]);

  function handleCellClick(index) {
    if (gameOver) return;
    if (marked[index]) return;

    const next = [...marked];
    next[index] = true;
    setMarked(next);

    socket.emit("markCell", { gameId, playerId, index });
  }

  return (
    <div className="game-root">
      <div className="game-main">
        <h2>Hra #{gameId}</h2>
        <p>Hráč: {playerName}</p>

        <div className="game-grid">
          {words.map((word, i) => (
            <button
              key={i}
              onClick={() => handleCellClick(i)}
              disabled={gameOver}
              className={`game-cell ${marked[i] ? "game-cell--marked" : ""} ${
                gameOver ? "game-cell--disabled" : ""
              }`}
            >
              {word}
            </button>
          ))}
        </div>

        {winner && (
          <div className="game-winner">
            <strong>Výhra!</strong> Hráč {winner.name} dokončil všechna pole.
          </div>
        )}
      </div>

      <div className="game-sidebar">
        <h3>Průběžné výsledky</h3>
        <ol>
          {scoreboard.map((p) => (
            <li key={p.playerId} className="game-score-row">
              {p.name} — {p.matchedCount}/{words.length}
              {p.finished ? " (dokončeno)" : ""}
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}

export default GameScreen;
